import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Footer from "./footer/footer.module"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Topbar from "./../components/topbar/topbar.module"
import Navbar from "./../components/navbar/navbar.module"
import {
  faFacebookSquare,
  faLinkedin,
  faInstagram,
  faYoutube,
  faTwitter,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons"

import {
  faAddressBook,
  faChartLine,
  faPhone,
  faMoneyCheckAlt,
  faUserCheck,
  faHome,
  faBriefcase,
  faTabletAlt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons"

library.add(
  faFacebookSquare,
  faLinkedin,
  faInstagram,
  faYoutube,
  faTwitter,
  faGoogle,
  faAddressBook,
  faChartLine,
  faPhone,
  faMoneyCheckAlt,
  faUserCheck,
  faHome,
  faBriefcase,
  faTabletAlt,
  faEnvelope
)

export default ({ children, breadcrumbs, title }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              websiteConfig {
                title
              }
            }
          }
        }
      `}
      render={data => {
        if (typeof window !== "undefined") {
          // eslint-disable-next-line global-require
          require("smooth-scroll")('a[href*="#"]')
        }

        return (
          <div className="container-fluid">
            <Topbar />
            <Navbar />
            {breadcrumbs && (
              <div className="breadcrumb">
                <FontAwesomeIcon icon="home" /> > {breadcrumbs}
              </div>
            )}

            {title && <h1>{title}</h1>}

            {children}
            <Footer />
          </div>
        )
      }}
    />
  )
}
